import React from "react"
import Lottie from "react-lottie"

export default class Icon extends React.Component {
  render() {
    return (
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData: {
            v: "5.5.10",
            fr: 30,
            ip: 0,
            op: 60,
            w: 300,
            h: 300,
            nm: "menu 3 option",
            ddd: 0,
            assets: [],
            layers: [
              {
                ddd: 0,
                ind: 1,
                ty: 4,
                nm: "Rectangle Copy 3",
                sr: 1,
                ks: {
                  o: { a: 0, k: 100, ix: 11 },
                  r: {
                    a: 1,
                    k: [
                      {
                        i: { x: [0.667], y: [1] },
                        o: { x: [0.333], y: [0] },
                        t: 10,
                        s: [0],
                      },
                      { t: 25, s: [180] },
                    ],
                    ix: 10,
                  },
                  p: {
                    a: 1,
                    k: [
                      {
                        i: { x: 0.667, y: 1 },
                        o: { x: 0.333, y: 0 },
                        t: 10,
                        s: [179, 182, 0],
                        to: [-9.667, 0, 0],
                        ti: [9.667, 0, 0],
                      },
                      { t: 25, s: [121, 182, 0] },
                    ],
                    ix: 2,
                  },
                  a: { a: 0, k: [0, 0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100, 100], ix: 6 },
                },
                ao: 0,
                shapes: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "rc",
                        d: 1,
                        s: { a: 0, k: [20, 20], ix: 2 },
                        p: { a: 0, k: [0, 0], ix: 3 },
                        r: { a: 0, k: 1, ix: 4 },
                        nm: "Rectangle Path 1",
                        mn: "ADBE Vector Shape - Rect",
                        hd: false,
                      },
                      {
                        ty: "st",
                        c: {
                          a: 0,
                          k: [
                            0.16470588235294117,
                            0.12941176470588237,
                            0.20784313725490197,
                            1,
                          ],
                          ix: 3,
                        },
                        o: { a: 0, k: 100, ix: 4 },
                        w: { a: 0, k: 6, ix: 5 },
                        lc: 1,
                        lj: 1,
                        ml: 4,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false,
                      },
                      {
                        ty: "tr",
                        p: { a: 0, k: [0, 0], ix: 2 },
                        a: { a: 0, k: [0, 0], ix: 1 },
                        s: { a: 0, k: [100, 100], ix: 3 },
                        r: { a: 0, k: 0, ix: 6 },
                        o: { a: 0, k: 100, ix: 7 },
                        sk: { a: 0, k: 0, ix: 4 },
                        sa: { a: 0, k: 0, ix: 5 },
                        nm: "Transform",
                      },
                    ],
                    nm: "Rectangle Copy 3",
                    np: 2,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false,
                  },
                ],
                ip: 0,
                op: 60,
                st: 0,
                bm: 0,
              },
              {
                ddd: 0,
                ind: 2,
                ty: 4,
                nm: "Rectangle Copy",
                sr: 1,
                ks: {
                  o: { a: 0, k: 100, ix: 11 },
                  r: {
                    a: 1,
                    k: [
                      {
                        i: { x: [0.667], y: [1] },
                        o: { x: [0.333], y: [0] },
                        t: 10,
                        s: [0],
                      },
                      { t: 25, s: [180] },
                    ],
                    ix: 10,
                  },
                  p: {
                    a: 1,
                    k: [
                      {
                        i: { x: 0.667, y: 1 },
                        o: { x: 0.333, y: 0 },
                        t: 10,
                        s: [179, 118, 0],
                        to: [0, 10.667, 0],
                        ti: [0, -10.667, 0],
                      },
                      { t: 25, s: [179, 182, 0] },
                    ],
                    ix: 2,
                  },
                  a: { a: 0, k: [0, 0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100, 100], ix: 6 },
                },
                ao: 0,
                shapes: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "rc",
                        d: 1,
                        s: { a: 0, k: [20, 20], ix: 2 },
                        p: { a: 0, k: [0, 0], ix: 3 },
                        r: { a: 0, k: 1, ix: 4 },
                        nm: "Rectangle Path 1",
                        mn: "ADBE Vector Shape - Rect",
                        hd: false,
                      },
                      {
                        ty: "st",
                        c: {
                          a: 0,
                          k: [0.7058823529411765, 0.6666666666666666, 1, 1],
                          ix: 3,
                        },
                        o: { a: 0, k: 100, ix: 4 },
                        w: { a: 0, k: 6, ix: 5 },
                        lc: 1,
                        lj: 1,
                        ml: 4,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false,
                      },
                      {
                        ty: "tr",
                        p: { a: 0, k: [0, 0], ix: 2 },
                        a: { a: 0, k: [0, 0], ix: 1 },
                        s: { a: 0, k: [100, 100], ix: 3 },
                        r: { a: 0, k: 0, ix: 6 },
                        o: { a: 0, k: 100, ix: 7 },
                        sk: { a: 0, k: 0, ix: 4 },
                        sa: { a: 0, k: 0, ix: 5 },
                        nm: "Transform",
                      },
                    ],
                    nm: "Rectangle Copy",
                    np: 2,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false,
                  },
                ],
                ip: 0,
                op: 60,
                st: 0,
                bm: 0,
              },
              {
                ddd: 0,
                ind: 3,
                ty: 4,
                nm: "Rectangle",
                sr: 1,
                ks: {
                  o: { a: 0, k: 100, ix: 11 },
                  r: {
                    a: 1,
                    k: [
                      {
                        i: { x: [0.667], y: [1] },
                        o: { x: [0.333], y: [0] },
                        t: 10,
                        s: [0],
                      },
                      { t: 25, s: [180] },
                    ],
                    ix: 10,
                  },
                  p: {
                    a: 1,
                    k: [
                      {
                        i: { x: 0.667, y: 1 },
                        o: { x: 0.333, y: 0 },
                        t: 10,
                        s: [121, 118, 0],
                        to: [9.667, 0, 0],
                        ti: [-9.667, 0, 0],
                      },
                      { t: 25, s: [179, 118, 0] },
                    ],
                    ix: 2,
                  },
                  a: { a: 0, k: [0, 0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100, 100], ix: 6 },
                },
                ao: 0,
                shapes: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "rc",
                        d: 1,
                        s: { a: 0, k: [20, 20], ix: 2 },
                        p: { a: 0, k: [0, 0], ix: 3 },
                        r: { a: 0, k: 1, ix: 4 },
                        nm: "Rectangle Path 1",
                        mn: "ADBE Vector Shape - Rect",
                        hd: false,
                      },
                      {
                        ty: "st",
                        c: {
                          a: 0,
                          k: [
                            0.16470588235294117,
                            0.12941176470588237,
                            0.20784313725490197,
                            1,
                          ],
                          ix: 3,
                        },
                        o: { a: 0, k: 100, ix: 4 },
                        w: { a: 0, k: 6, ix: 5 },
                        lc: 1,
                        lj: 1,
                        ml: 4,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false,
                      },
                      {
                        ty: "tr",
                        p: { a: 0, k: [0, 0], ix: 2 },
                        a: { a: 0, k: [0, 0], ix: 1 },
                        s: { a: 0, k: [100, 100], ix: 3 },
                        r: { a: 0, k: 0, ix: 6 },
                        o: { a: 0, k: 100, ix: 7 },
                        sk: { a: 0, k: 0, ix: 4 },
                        sa: { a: 0, k: 0, ix: 5 },
                        nm: "Transform",
                      },
                    ],
                    nm: "Rectangle",
                    np: 2,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false,
                  },
                ],
                ip: 0,
                op: 60,
                st: 0,
                bm: 0,
              },
              {
                ddd: 0,
                ind: 4,
                ty: 4,
                nm: "Rectangle Copy 2",
                sr: 1,
                ks: {
                  o: { a: 0, k: 100, ix: 11 },
                  r: {
                    a: 1,
                    k: [
                      {
                        i: { x: [0.667], y: [1] },
                        o: { x: [0.333], y: [0] },
                        t: 10,
                        s: [0],
                      },
                      { t: 25, s: [180] },
                    ],
                    ix: 10,
                  },
                  p: {
                    a: 1,
                    k: [
                      {
                        i: { x: 0.667, y: 1 },
                        o: { x: 0.333, y: 0 },
                        t: 10,
                        s: [121, 182, 0],
                        to: [0, -10.667, 0],
                        ti: [0, 10.667, 0],
                      },
                      { t: 25, s: [121, 118, 0] },
                    ],
                    ix: 2,
                  },
                  a: { a: 0, k: [0, 0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100, 100], ix: 6 },
                },
                ao: 0,
                shapes: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "rc",
                        d: 1,
                        s: { a: 0, k: [20, 20], ix: 2 },
                        p: { a: 0, k: [0, 0], ix: 3 },
                        r: { a: 0, k: 1, ix: 4 },
                        nm: "Rectangle Path 1",
                        mn: "ADBE Vector Shape - Rect",
                        hd: false,
                      },
                      {
                        ty: "st",
                        c: {
                          a: 0,
                          k: [0.7058823529411765, 0.6666666666666666, 1, 1],
                          ix: 3,
                        },
                        o: { a: 0, k: 100, ix: 4 },
                        w: { a: 0, k: 6, ix: 5 },
                        lc: 1,
                        lj: 1,
                        ml: 4,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false,
                      },
                      {
                        ty: "tr",
                        p: { a: 0, k: [0, 0], ix: 2 },
                        a: { a: 0, k: [0, 0], ix: 1 },
                        s: { a: 0, k: [100, 100], ix: 3 },
                        r: { a: 0, k: 0, ix: 6 },
                        o: { a: 0, k: 100, ix: 7 },
                        sk: { a: 0, k: 0, ix: 4 },
                        sa: { a: 0, k: 0, ix: 5 },
                        nm: "Transform",
                      },
                    ],
                    nm: "Rectangle Copy 2",
                    np: 2,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false,
                  },
                ],
                ip: 0,
                op: 60,
                st: 0,
                bm: 0,
              },
              {
                ddd: 0,
                ind: 5,
                ty: 4,
                nm: "background",
                sr: 1,
                ks: {
                  o: { a: 0, k: 0, ix: 11 },
                  r: { a: 0, k: 0, ix: 10 },
                  p: { a: 0, k: [150, 150, 0], ix: 2 },
                  a: { a: 0, k: [7, -1, 0], ix: 1 },
                  s: { a: 0, k: [156.25, 156.25, 100], ix: 6 },
                },
                ao: 0,
                shapes: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "rc",
                        d: 1,
                        s: { a: 0, k: [192, 192], ix: 2 },
                        p: { a: 0, k: [0, 0], ix: 3 },
                        r: { a: 0, k: 0, ix: 4 },
                        nm: "Rectangle Path 1",
                        mn: "ADBE Vector Shape - Rect",
                        hd: false,
                      },
                      {
                        ty: "fl",
                        c: { a: 0, k: [0.97, 0.6, 0.6, 1], ix: 4 },
                        o: { a: 0, k: 100, ix: 5 },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false,
                      },
                      {
                        ty: "tr",
                        p: { a: 0, k: [7, -1], ix: 2 },
                        a: { a: 0, k: [0, 0], ix: 1 },
                        s: { a: 0, k: [100, 100], ix: 3 },
                        r: { a: 0, k: 0, ix: 6 },
                        o: { a: 0, k: 100, ix: 7 },
                        sk: { a: 0, k: 0, ix: 4 },
                        sa: { a: 0, k: 0, ix: 5 },
                        nm: "Transform",
                      },
                    ],
                    nm: "Rectangle 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false,
                  },
                ],
                ip: 0,
                op: 150.000006109625,
                st: 0,
                bm: 0,
              },
            ],
            markers: [],
          },
          rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
          },
        }}
        height={150}
        width={150}
      />
    )
  }
}
